<template>
  <div class="dashboard-stats">
    <div class="dashboard-stats__row" v-for="({ name, count, all, color }, i) in lines" :key="i">
      <div class="dashboard-stats__head">
        <div class="dashboard-stats__title">{{ name }}</div>
        <div class="dashboard-stats__count">{{ count }}/{{ all }}</div>
      </div>
      <div class="dashboard-stats__line">
        <div class="dashboard-stats__val" :style="getStyle(count, all, color)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";

const _line = (name, count, all, color) => ({ name, count, all, color })

export default {
  name: 'dashboardStats',
  data() {
    return {
      colors: {
        'lecture': '#003882',
        'presentation': '#DE8703',
        'discussion': '#C34343',
        'qa': '#00A6E3',
        'workshop': '#474747',
      }
    }
  },
  computed: {
    ...mapState('events', ['metric']),
    ...mapActions('events', ['getMetric']),
    lines() {
      return Object.entries(this.metric).map(([k, v]) => {
        return _line(this.getName(k), v['done'], v['all'], this.colors[k])
      })
    }
  },
  methods: {
    getStyle(count, all, color) {
      return {
        width: `${(count / all) * 100}%`,
        background: color,
      }
    },
    getName(name) {
      return this.$t('pages.dashboard.stats.lines.' + name)
    }
  },
}
</script>

<style lang="scss">
.dashboard-stats {
  &__row + &__row {
    margin-top: 5px;
  }
  &__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    font-weight: 400;
    font-size: 12px;
    line-height: 147.5%;
  }

  &__count {
    font-weight: 700;
    font-size: 10px;
    line-height: 130%;
  }

  &__line {
    display: flex;
    background: rgba($dark, 0.3);
    border-radius: 10px;
    overflow: hidden;
    height: 7px;
    margin-top: 2px;
  }
  &__val {
    border-radius: 10px;
    height: 7px;
  }
}
</style>
